import { getHost } from "../utils";
export const getClientHostFromRequest = (req) => getHost(req.headers.origin) ||
    req.headers.host || "";
